var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"section section-1",style:({ transform: `translateY(${_vm.section1Offset}px)` })},[_c('h1',[_vm._v("Section 1")])]),_c('div',{staticClass:"section section-2",style:({ transform: `translateY(-${_vm.section2Offset}px)` })},[_c('h1',[_vm._v("Section 2")])]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section section-2"},[_c('h1',[_vm._v("Section 3")])])
}]

export { render, staticRenderFns }